export default __webpack_public_path__ + "static/media/golo-fireball.ea60f9d4.png";